import type { SerializedConstructor } from '@langchain/core/load/serializable';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = [
  'gemini-2.5-pro',
  'gemini-2.5-flash',
  'gemini-2.5-flash-lite',
  'gemini-2.0-flash',
  'gemini-2.0-flash-exp',
  'gemini-1.5-pro',
  'gemini-1.5-flash',
].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'gemini-2.5-flash';

export function useGoogleVertexAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model || DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}
